<template lang="pug">
	.page-not-found.admin.theme-1
		.page-error.tile
			h1.text-info
				i.fas.fa-hard-hat
				|  Under Construction!
			p The page is still under construction
			p: a.btn.btn-primary(href="javascript:window.history.back();") Go Back
</template>

<script>
export default {

  name: 'under-construction',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>